import { useMemo } from 'react'
import _ from 'lodash'

import { API, getHeadersFactory, getUriFactory } from './core'
import { apiURL } from 'admin/msal-config'

import { useAuth } from './auth'

export function useApi() {
  const { ready, getToken } = useAuth()

  return useMemo(() => {
    if (ready) {
      return new API(
        getUriFactory(apiURL),
        getHeadersFactory(getToken, { originatorApp: 'newadmin' })
      )
    }
    return null
  }, [getToken, ready])
}

/**
 * @param {Record<string, Promise<[any, Number, String]>>} requests
 * @returns {Promise<[Record<string, any>, Number, String]>}
 */
export async function mergeApiRequests(requests = {}) {
  const keys = Object.keys(requests)
  const completedRequests = await Promise.all(Object.values(requests))

  for (const result of completedRequests) {
    const [, , error] = result
    if (error) {
      return result
    }
  }

  const [, status] = completedRequests[0]
  return [
    _.zipObject(
      keys,
      completedRequests.map(([data]) => data)
    ),
    status,
    null
  ]
}
